import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Dialog zur AblaufDB-Verwaltung: XML-Datei laden, Infos anzeigen, Bearbeiten öffnen, entladen.
 */
function AblaufDbDialog({
  open,
  onClose,
  ablaufDbData,
  ablaufDbName,
  ablaufDbPath,
  onFileSelect,
  onLoadFromZAxml,
  onOpenEditor,
  onUnload,
}) {
  const { t } = useTranslation();
  const fileInputRef = useRef(null);

  if (!open) return null;

  const hasData = ablaufDbData && ablaufDbData.length > 0;

  const handleLoadFromZAxml = async () => {
    const result = await onLoadFromZAxml();
    if (result && result.success) {
      onClose();
    } else if (result && result.error) {
      alert(t('alerts.ablaufdb_error', { msg: result.error }));
    }
  };

  const handleUnload = () => {
    onUnload();
    onClose();
  };

  return (
    <div className="edit-overlay" onClick={onClose}>
      <div className="edit-modal" onClick={(e) => e.stopPropagation()}>
        <div className="edit-header">
          <h3>🗄️ {t('ablaufdb.title')}</h3>
          <button className="btn-close" onClick={onClose} type="button">×</button>
        </div>
        <div className="edit-content">
          {!hasData ? (
            <div>
              <p style={{ marginBottom: '16px', color: '#6b7280' }}>
                {t('ablaufdb.not_loaded')}
              </p>
              <button
                className="btn btn-primary"
                onClick={() => fileInputRef.current?.click()}
                type="button"
              >
                📁 {t('ablaufdb.select_xml')}
              </button>
              <input
                type="file"
                ref={fileInputRef}
                onChange={onFileSelect}
                accept=".xml"
                style={{ display: 'none' }}
              />
              <button
                className="btn btn-secondary"
                onClick={handleLoadFromZAxml}
                style={{ marginLeft: '8px' }}
                type="button"
              >
                🔄 {t('ablaufdb.load_from_zaxml')}
              </button>
            </div>
          ) : (
            <div>
              <div className="ablaufdb-info" style={{ marginBottom: '16px' }}>
                <strong>{t('ablaufdb.loaded_file')}</strong> {ablaufDbName || t('report.unknown')}<br />
                <strong>{t('ablaufdb.path')}</strong> {ablaufDbPath || t('ablaufdb.not_saved')}<br />
                <strong className="ablaufdb-kuerzel-count">{t('ablaufdb.kuerzel_count')}</strong> {ablaufDbData.length}
              </div>
              <div className="form-actions">
                <button
                  className="btn btn-primary"
                  onClick={() => {
                    onOpenEditor();
                    onClose();
                  }}
                  type="button"
                >
                  ✏️ {t('ablaufdb.edit')}
                </button>
                <button
                  className="btn btn-secondary"
                  onClick={() => fileInputRef.current?.click()}
                  type="button"
                >
                  📁 {t('ablaufdb.load_other')}
                </button>
                <button
                  className="btn btn-secondary"
                  onClick={handleUnload}
                  title={t('ablaufdb.without_db_title')}
                  type="button"
                >
                  {t('ablaufdb.without_db')}
                </button>
                <input
                  type="file"
                  ref={fileInputRef}
                  onChange={onFileSelect}
                  accept=".xml"
                  style={{ display: 'none' }}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default AblaufDbDialog;
